/**
 * Service Worker
 * 使用workbox实现 由以下三个文件配合
 * 1、vue.config.js GenerateSW  实现 缓存策略和缓存文件配置
 * 2、src/utils/sw-register.js  实现 sw注册 & sw注销 功能
 * 3、server/middlewares/serviceWorker.js  实现 sw 文件路径访问重定向
 */
import { getLocale } from '@/utils/locale'
const isPro = process.env.NODE_ENV === 'production' && process.env.BUILD_ENV !== 'development'

export default function swRegister() {
  if (isPro && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const food = isPro ? `/${getLocale()}/food` : ''
      navigator.serviceWorker
        .register(`${food}/sw-c.js`, { scope: `${food}/` })
        .then(registration => {
          console.log('SW registered: ', registration)
        })
        .catch(registrationError => {
          console.log('SW registration failed: ', registrationError)
        })
    })
    // navigator.serviceWorker.addEventListener('controllerchange', () => {
    //   if(refreshing) return
    //   refreshing = true
    //   window.location.reload()
    // })
  }
}

export function swUnregister() {
  if ('serviceWorker' in navigator) {
    try {
      // 批量清除 CacheStorage 或者自定义具名清除
      caches.keys().then(keys => {
        keys.forEach(key => {
          caches.delete(key)
        })
      })
    } catch (error) {}
    navigator.serviceWorker.ready.then(registration => {
      registration.unregister()
    })
  }
}
